import React, { Component } from "react";
import { View,  StyleSheet, TouchableHighlight } from "react-native";
import Text from "../components_v2/TextFont";
import Theme from "../argon-ui/Theme";
import ArTheme from "../argon-ui/Theme";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";

class MiniAddButton extends Component {
  handleOnPress = () => {
    this.props.onPress && this.props.onPress();
  };
  render() {
    return (
      <TouchableHighlight style={{marginBottom:15}} onPress={this.handleOnPress} underlayColor="transparent">
        <View style={{ flexDirection: "column" }}>
          <View
            style={style.btnMiniAdd}
            onPress={this.handleOnPress}
          >
            <FontAwesomeIcon icon={this.props.icon} color="#FFF" size={20} />
          </View>

          <Text style={style.btnMiniAddTitle}>{this.props.text}</Text>
        </View>
      </TouchableHighlight>
    );
  }
}

const style = StyleSheet.create({
  btnMiniAdd: {
    width: 50,
    height: 50,
    borderRadius: 25,
    shadowColor: ArTheme.COLORS.PRIMARY,
    shadowRadius: 5,
    elevation: 15,
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 5,
    backgroundColor : ArTheme.COLORS.PRIMARY
  },
  btnMiniAddTitle: {
    // backgroundColor: Theme.COLORS.BACKGROUND,
    color: Theme.COLORS.WHITE,
    padding:5,
    borderRadius: 5,
    textAlign: "center",
    // marginBottom: 10,
    fontSize: 16
  }
});
export default MiniAddButton;
